'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');
var pbizServer = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);

var utils = require('../../utils/main');
var modal = require('../../modal');
var appDom = require('../../app-dom');

var dom;
var addToCartText;

var setupDom = function() {

	dom = {};
	dom.bookingForm = appDom.document.find('.scheduler-detail__booking-form');

};

var addEventHandlers = function() {

	appDom.document.on('click', '.js-book-now-btn', onBookNowClicked);
	appDom.document.on('click', '.scheduler-modal__close-btn', onModalCloseBtnClicked);
	appDom.document.on('click', '.scheduler-detail__booking-form-add-to-cart-btn', onAddToCartBtnClicked);
	appDom.document.on('item_added_to_cart', resetBookingForm);
	dom.bookingForm.on('submit', onBookingFormSubmitted);

};

var resetBookingForm = function(e, data) {

	console.log(arguments);
	console.log(data.$scheduler);
	console.log(data.$scheduler[0]);

	// data.$scheduler.find('.scheduler-detail__booking-form')[0].reset();

	dom.bookingForm.empty();
	window.scrollTo(0,0);

};

var onAddToCartBtnClicked = function(e) {

	var $addToCartBtn = $(this);
	var $scheduler = $addToCartBtn.parents('.scheduler-detail');
	var $serviceForm = $scheduler.find('.scheduler-detail__service-form');
	var $bookingForm = $scheduler.find('.scheduler-detail__booking-form');
	var $scheduleBtn = $scheduler.find('.scheduler-detail__schedule-btn');
	var data = {};
	var serviceFormData = grabFormData($serviceForm.serializeArray());
	var bookingFormData = grabFormData($bookingForm.serializeArray());

	$.extend(data, serviceFormData);
	$.extend(data, bookingFormData);

	// not intended to be "var" (this is a module wide variable)
	addToCartText = $addToCartBtn.text();

	$addToCartBtn.text(pbizServer.content['Generic.Loading']);

	// add some custom goodies
	data['sku'] = $scheduleBtn.attr('data-sku') ? $scheduleBtn.attr('data-sku') : '';
	data['sourceUrl'] = $scheduleBtn.attr('data-item-url');
	data['itemId'] = $scheduleBtn.attr('data-item-id');
	data['itemType'] = 'scheduler';

	e.preventDefault();

	$.ajax({
		url: '/index.cfm?action=scheduler.processAddToCart',
		method: 'POST',
		dataType: 'JSON',
		data: data
	}).done(function(response) {

		onAddToCartLinkClickedDone(response, $scheduler);

	});

};


var onAddToCartLinkClickedDone = function(response, $scheduler) {

	console.log('set the button text back!');
	console.log(addToCartText);

	$scheduler.find('.scheduler-detail__booking-form-add-to-cart-btn').text(addToCartText);

	if (response.status.code) {

		triggerCustomEvent('item_added_to_cart', {
			data: {
				$scheduler: $scheduler
			}
		});

	} else {

		notify.show({
			target: $scheduler.find('[name="' + response.target + '"]'),
			msg: response.status.msg,
			closeOnClick: true
		});

	}

};

var onBookNowClicked = function(e) {

	e.preventDefault();

	$(this).parents('.scheduler-detail__booking-form').submit();

};

var onModalCloseBtnClicked = function(e) {

	// Don't try and close the modal if we got here by responding to the modal_closed event
	if (e.type !== 'modal_closed') {

		modal.close();

	}

	window.scrollTo(0,0);
	window.location.reload();

};

var grabFormData = function(formArray) {

	var returnArray = {};

	for (var i = 0; i < formArray.length; i++){
		returnArray[formArray[i]['name']] = formArray[i]['value'];
	}

	return returnArray;

};

var onBookingFormSubmitted = function(e) {

	console.log('booking form submitted');
	console.log($(this));

	e.preventDefault();

	var $bookingForm = $(this);
	var data = grabFormData($bookingForm.serializeArray());
	var $serviceForm = $bookingForm.parents('.scheduler-detail').find('.scheduler-detail__service-form');
	var $options = $serviceForm.find('[name^="optionID_"],[name^="option_custom_"]');

	$options.each(function(i, el) {
		data[$(el).attr('name')] = $(el).val();
	});

	e.preventDefault();

	$.ajax({
		url: utils.getUrl('scheduler.processBooking'),
		type: 'post',
		data: data
	}).done(function(response) {

		onBookingFormSubmittedDone(response, $bookingForm);

	});

};

var onBookingFormSubmittedDone = function(response, $bookingForm) {

	// default the "target" field to the first visible
	var $target = $bookingForm.find('input:visible').eq(0);

	// if target was explicitly provided, use the provided target
	if (response.target) {
		$target = $bookingForm.find('[name="' + response.target + '"]');
	}

	if (response.status.code) {

		modal.open({
			url: utils.getUrl('scheduler.bookSuccess'),
			data: {
				appointmentDate: response.appointmentDate,
				notificationSubject: response.notificationSubject,
				notificationMessage: response.notificationMessage,
				appointmentIdEncrypted: response.appointmentIdEncrypted
			}
		}).done(function() {

			// Handle scenario where user closes the modal via the modal "X" button
			appDom.document.one('modal_closed', onModalCloseBtnClicked);

		});

	} else {

		$target.focus();

		notify.show({
			msg: response.status.msg,
			target: $target,
			container: $bookingForm,
			closeOnClick: true
		});

	}

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
};
